import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;

  handleClose(): void;
}

const LinkedinAccountNotFoundDialog: React.FC<Props> = ({ open, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('linkedinAccountNotFoundTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>{t('linkedinAccountNotFoundContent1')}</Typography>
          <Typography className={classes.text}>{t('linkedinAccountNotFoundContent2')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default LinkedinAccountNotFoundDialog;
